import { CloseIcon } from "@chakra-ui/icons";
import { Flex, Button, Box } from "@chakra-ui/react";
import { FunnelComponentProps, FunnelContextArea } from "../../funnel/types";
import { CaretLeftLargeIcon } from "../../icons/CaretLeftLargeIcon";
import { FUNNEL_TYPES } from "../../funnel/utils/contants";
import { useUserData } from "../../../hooks/useUserData";

export function PurchaseReleaseModalHeader({
  release,
  modalContext,
  setFunnelType,
  onClose,
}: FunnelComponentProps) {
  const { userData } = useUserData();
  const { ppb_gold_price_point, premium_only } = release ?? {};

  const isGoldUser = userData?.gold ?? false;

  const isContextWithNoX = modalContext === FunnelContextArea.verticalReader;
  const isContextWithPrePaywall =
    modalContext === FunnelContextArea.reader ||
    modalContext === FunnelContextArea.verticalReader;

  const hasBackButton =
    isContextWithPrePaywall &&
    !isGoldUser &&
    (!premium_only || ppb_gold_price_point);

  return (
    <Flex flexDirection="row" justifyContent="space-between" width="100%" padding="16px 24px">
      <Box>
        {hasBackButton && (
          <Button
            variant="iconOnly"
            onClick={() => setFunnelType(FUNNEL_TYPES.prePaywall)}
            minWidth={0}
          >
            <CaretLeftLargeIcon color="dune.400" boxSize="20px" />
          </Button>
        )}
      </Box>
      {isContextWithNoX ? null : (
        <Button
          alignSelf="center"
          variant="iconOnly"
          onClick={onClose}
          minWidth={0}
        >
          <CloseIcon alignSelf="center" color="dune.100" />
        </Button>
      )}
    </Flex>
  );
}
